"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerNodesTable = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var NodeRow_1 = require("./NodeRow");
/**
 * LayerNodesTable - Editable table of strategy elements belonging to a
 * single layer. Always rendered when the parent layer is expanded.
 */
exports.LayerNodesTable = function (_a) {
    var column = _a.column, nextLayerNodes = _a.nextLayerNodes, onUpdateNode = _a.onUpdateNode, onUpdateConnectionWeight = _a.onUpdateConnectionWeight, onDeleteNode = _a.onDeleteNode, onAddNode = _a.onAddNode;
    return (react_1.default.createElement("div", { className: "ws-nodes-container" },
        react_1.default.createElement("table", { className: "ws-nodes-table" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { style: { width: "190px" } }, "Element Name"),
                    react_1.default.createElement("th", { style: { width: "120px" } }, "Connects To"),
                    react_1.default.createElement("th", null, "Edge Weight"),
                    react_1.default.createElement("th", { style: { width: "50px" } }))),
            react_1.default.createElement("tbody", null,
                (column.nodes || []).map(function (node) { return (react_1.default.createElement(NodeRow_1.NodeRow, { key: node.id, node: node, nextLayerNodes: nextLayerNodes, onUpdateNode: function (updates) { return onUpdateNode(node.id, updates); }, onUpdateConnectionWeight: function (targetNodeId, weightType) {
                        return onUpdateConnectionWeight(node.id, targetNodeId, weightType);
                    }, onDelete: function () { return onDeleteNode(node.id); } })); }),
                react_1.default.createElement("tr", { className: "ws-add-element-row" },
                    react_1.default.createElement("td", { colSpan: 4 },
                        react_1.default.createElement(Button_1.DefaultButton, { iconProps: { iconName: "Add" }, text: "Add Element", title: "Add a new element", ariaLabel: "Add a new element", className: "ws-admin-button-add ws-admin-button-hover-accent", onClick: onAddNode })))))));
};
